export default __webpack_public_path__ + "static/ec-3ea7f906eaf807123a280d5806787ff2.svg";